import Swiper from 'swiper/bundle';

export default function blockImageSlider() {
  document.querySelectorAll('.image-slider:not(.image-slider--disabled)').forEach(function (slider) {
    const swiper = new Swiper(slider, {
      speed: 1000,
      loop: false,
      parallax: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
      },

      on: {
        init: function () {
          const activeSlide = this.slides[this.activeIndex];
          const activeItem = activeSlide.querySelector('.image-slider__image');
          if (activeItem) {
            activeItem.classList.add('image-slider__image--active');
          }

          const video = activeSlide.querySelector('video');
          this.params.autoplay.delay = video ? 15000 : 5000;
          this.autoplay.start();
        },

        slideChange: function () {
          const activeIndex = this.activeIndex;
          const lastIndex = this.slides.length - 1;

          if (activeIndex === lastIndex) {
            this.autoplay.stop();
          }

          this.slides.forEach((slide, index) => {
            const item = slide.querySelector('.image-slider__image');
            if (item) {
              if (index === activeIndex) {
                item.classList.add('image-slider__image--active');
              } else {
                setTimeout(() => {
                  item.classList.remove('image-slider__image--active');
                }, 1000);
              }
            }
          });

          const activeSlide = this.slides[activeIndex];
          const video = activeSlide.querySelector('video');
          this.params.autoplay.delay = video ? 15000 : 5000;
          this.autoplay.start();
        },

        transitionStart: function () {
          const videos = this.el.querySelectorAll('video');
          videos.forEach((video) => video.pause());
        },

        transitionEnd: function () {
          const activeSlide = this.slides[this.activeIndex];
          const video = activeSlide.querySelector('video');
          if (video) {
            video.play();
          }
        },
      },
    });
  });
}
